import {
  Box,
  CardMedia,
  Grid,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { InTheN4, Person } from "../../constant";
import { LinkedIn } from "@mui/icons-material";
import { newCarauselData } from "../../helper";
import { article } from "framer-motion/client";
import { useNavigate } from "react-router-dom";

const MainContainer = styled(Box)(({ theme }) => ({
  background: "#000",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "60px 24px",
  position: "relative",
  overflow: "hidden",

  "&::after": {
    content: '""',
    position: "absolute",
    width: "95%",
    height: "80%",
    left: "65%",
    top: "10%",
    bottom: "10%",
    transform: "translateX(-100%), translateY(-50%)",
    background:
      "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
    filter: "blur(100px)",
    //backdropFilter: "blur(500px)",
    zIndex: 0,
  },
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  position: "relative",
  zIndex: 1,
  [theme.breakpoints.down("md")]: {
    width: "95%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

const CardsContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(4),
  marginTop: theme.spacing(0),
  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(0),
  },
}));

const Card = styled(Box)(({ theme }) => ({
  background:
    "radial-gradient(90.16% 143.01% at 15.32% 21.04%, rgba(165, 239, 255, 0.2) 0%, rgba(110, 191, 244, 0.0447917) 77.08%, rgba(70, 144, 213, 0) 100%)",
  color: "white",
  borderRadius: 16,
  padding: theme.spacing(4),
  width: "100%",
  maxWidth: 380,
  minHeight: 500,
  display: "flex",
  flexDirection: "column",
  transition: "all 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
  position: "relative",
  overflow: "hidden",
  marginTop: "40px",

  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
    minHeight: 450,
  },

  "&:hover": {
    transform: "translateY(-8px)",
    boxShadow: "0 15px 30px rgba(0,0,0,0.3)",
  },
}));

//this function will fetch 2 random articles from main data.
const getRandomArticles = (data, count = 2) => {
  const shuffled = data.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

const data = getRandomArticles(newCarauselData)

export default function NewsroomDetailsPage({ data }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  const handlReadMore = (slug) => {
    if (!slug) return;

    navigate(`/newsroom-details/${slug}`);
  };

  return (
    <>
      <MainContainer>
        <ContentWrapper>
          <Grid container spacing={4}>
            {/* Left Column */}
            <Grid item xs={12} sm={12} md={7}>
              {/* Image Title */}
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 2,
                  overflow: "hidden",
                  height: "420px",
                }}
              >
                <CardMedia
                  component="img"
                  height="100%"
                  image={data?.article?.heroImageUrl}
                  alt="Thought Leadership"
                />
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    padding: 4,
                    width: "100%",
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)",
                  }}
                >
                  <Typography
                    sx={{ color: "#8C8CC2", fontSize: "16px", mb: 2 }}
                  >
                    {data?.article?.sourceName} -{" "}
                    {new Date(data?.article?.publishedAt).toLocaleDateString("en-GB", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{
                      color: "white",
                      fontSize: "24px",
                      fontWeight: 700,
                      mb: 2,
                    }}
                  >
                    {data?.article?.title}
                  </Typography>
                </Box>
              </Box>
              {/* Title Details */}
              <Box>
                <Typography
                  sx={{ color: "#8C8CC2", fontSize: "16px", mb: 2, mt: 5 }}
                >
                  {data?.article?.sourceName} -{" "}
                  {new Date(data?.article?.publishedAt).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    color: "white",
                    fontSize: "24px",
                    fontWeight: 700,
                    mb: 2,
                  }}
                >
                  {data?.article?.title}
                </Typography>
                <Typography sx={{ color: "#fff", fontSize: "16px", mb: 2, lineHeight: '30px' }}>
                  {data?.article?.excerpt}
                </Typography>
                {data?.article?.contentJson?.map((item, index) => {
                  const text =
                    item?.segments?.map((segment) => segment.text).join(" ") || "";

                  switch (item.variant) {
                    case "sectionHeading":
                      return (
                        <Typography
                          key={index}
                          sx={{
                            color: "#5A5CFF",
                            fontSize: "24px",
                            fontWeight: 700,
                            mb: 2,
                            mt: 3,
                          }}
                        >
                          {text}
                        </Typography>
                      );

                    case "paragraph":
                      return (
                        <Typography
                          key={index}
                          sx={{
                            color: "#FFFFFF",
                            fontSize: "16px",
                            lineHeight: "30px",
                            mb: 2,
                          }}
                        >
                          {text}
                        </Typography>
                      );

                    case "eyebrow":
                      return (
                        <Typography
                          key={index}
                          sx={{
                            color: "#8C8CC2",
                            fontSize: "14px",
                            fontWeight: 600,
                            mb: 1,
                            textTransform: "uppercase",
                          }}
                        >
                          {text}
                        </Typography>
                      );

                    default:
                      return null;
                  }
                })}
              </Box>
            </Grid>
            {/* Right Column */}
            <Grid item xs={12} sm={12} md={5}>
              {/* Profile */}
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 2,
                  overflow: "hidden",
                  height: isMobile ? "auto" : "420px",
                  background:
                    "linear-gradient(262.41deg, #1DA1F2 -8.32%, #6843EC 93.3%)",
                  padding: 4,

                }}
              >
                <img
                  src={data?.article?.sidebarCardJson?.avatarUrl}
                  alt="Profile Image"
                  style={{
                    width: "150px",
                    borderRadius: "10px",
                    height: "150px",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
                {/* <LinkedIn
                  sx={{ color: "blue", fontSize: "36px", marginLeft: 2 }}
                /> */}
                <Box>
                  <Typography
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "24px",
                      fontWeight: 700,
                      mb: 2,
                    }}
                  >
                    {data?.article?.sidebarCardJson?.title}
                  </Typography>
                  <Typography
                    sx={{ color: "#FFFFFF", fontSize: "16px", mb: 2 }}
                  >
                    {data?.article?.sidebarCardJson?.subtitle}
                  </Typography>
                  <Typography
                    sx={{ color: "#FFFFFF", fontSize: "16px", mb: 2 }}
                  >
                    {data?.article?.sidebarCardJson?.description}
                  </Typography>
                </Box>
              </Box>
              {/* Related Title */}
              <Box sx={{ mt: 5 }}>
                <Typography
                  sx={{ color: "#5A5CFF", fontSize: "28px", fontWeight: 700 }}
                >
                  Related Articles
                </Typography>
                <Box>
                  <CardsContainer>
                    {data?.relatedArticles?.map((card, index) => (
                      <Card key={index}
                        onClick={()=>handlReadMore(card?.slug)}>
                        <Box
                          sx={{
                            transition: "transform 0.8s ease",
                            textAlign: "left",
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-end",
                            transform: "translateY(30px)",
                          }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              height: { xs: 220, md: 260 },
                              overflow: "hidden",
                              borderRadius: "12px",
                              backgroundColor: "#111",
                              mb: 2,
                            }}
                          >
                            <img
                              src={card?.heroImageUrl}
                              alt={card?.title}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                                transition: "transform 0.4s ease",
                              }}
                            />
                          </Box>
                          <Box
                            display={"flex"}
                            flexDirection={"row"}
                            justifyContent={"space-between"}
                            marginTop={2}
                          >
                            <Typography
                              sx={{ color: "#8C8CC2", fontSize: "14px" }}
                            >
                              {card?.sourceName}
                            </Typography>
                            <Typography
                              sx={{ color: "#8C8CC2", fontSize: "14px" }}
                            >
                              {card?.date}
                            </Typography>
                          </Box>
                          <Typography
                            variant="h4"
                            sx={{
                              color: "#fff",
                              fontSize: { xs: 20, md: 24 },
                              fontWeight: 600,
                              mb: 2,
                            }}
                          >
                            {card?.title}
                          </Typography>

                          <Typography
                            variant="body1"
                            sx={{
                              color: "#B0B0B0",
                              fontSize: { xs: 14, md: 16 },
                              lineHeight: 1.6,
                              mb: 3,
                            }}
                          >
                            {card.excerpt}
                          </Typography>
                          <Typography
                            sx={{
                              color: " #61D1FA",
                              fontSize: 14,
                              mb: 2,
                            }}
                          >
                            {`Read More →`}
                          </Typography>
                        </Box>
                      </Card>
                    ))}
                  </CardsContainer>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </ContentWrapper>
      </MainContainer>
    </>
  );
}
